import React from 'react'
import NumberInput from '../../../components/NumberInput'

interface IBalanceInputProps {
  amount: string
  onAmount: (amount: string) => void
  ticker: string
  availableBalance: number
  showMax?: boolean
}

const BalanceInput = ({ amount, onAmount, ticker, availableBalance, showMax = true }: IBalanceInputProps): JSX.Element => {
  return (
    <div style={{
      display: 'flex',
      paddingInline: 16,
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      height: 50,
      borderRadius: 8,
      background: 'rgba(239, 240, 248, 0.60)',
      boxShadow: '0 1px 1px 0 rgba(226, 228, 239, 0.50)'
    }}>
      <NumberInput
        onUserInput={onAmount}
        placeholder='0'
        value={amount}
        style={{
          boxShadow: 'none',
          padding: 0,
          fontSize: 18,
          border: 0,
          fontWeight: 400,
          background: 'transparent'
        }}
      />
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{

          color: '#747894',
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: '20px',
          letterSpacing: 0
        }}>{ticker}</span>
        {showMax && (
          <button style={{
            border: 'none',
            borderRadius: 4,
            padding: '4px 8px',
            background: 'rgba(198, 213, 255, 0.70)',
            color: '#2A63FF',
            cursor: 'pointer'

          }}
          onClick={() => onAmount(availableBalance.toString())}
          >
          MAX
          </button>
        )}
      </div>
    </div>
  )
}

export default BalanceInput
